export default function LoadingSpinner({ label }) {
  return (
    <div className="center">
      <div className="spinner" />
      {label && <p className="muted">{label}</p>}
    </div>
  );
}
